/** Wall-clock budgets. The browser leaves time for the Worker to return its error. */
export const API_TIMEOUT_MS = 25_000;
export const ASK_REQUEST_TIMEOUT_MS = 90_000;
export const ASK_PIPELINE_TIMEOUT_MS = 75_000;
export const CLIENT_TIMEOUT_GRACE_MS = 10_000;
export const TEACHING_SEARCH_TIMEOUT_MS = 20_000;
export const TEACHING_SELECTION_TIMEOUT_MS = 25_000;
/** A standards extraction streams until this, then keeps the rows it has (KTD5). Inside the 90 s request budget. */
export const EXTRACTION_DEADLINE_MS = 75_000;
/**
 * The handler's own bound on an extraction: past the model's deadline, so the adapter gets to
 * salvage first, and inside the request budget, so a stalled call is still answered as a
 * failed extraction (with its event) rather than by the router's anonymous 504.
 */
export const EXTRACTION_PIPELINE_TIMEOUT_MS = 80_000;
